import generateTimeStampFromDate from "../Date/GenerateTimeStampFromDate";

const checkDateInput = (value) => {
  return value ? (value._d ? generateTimeStampFromDate(value._d) : value) : "";
};

export default checkDateInput;
